module.exports = __webpack_public_path__ + "img/faramugo-konfigurator-template.ab0599d0.png";